module.exports = __webpack_public_path__ + "img/3.1c4a0cd6.jpg";